import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Place } from '../models/Place';
import { PlaceDetailsElectricity } from "../models/PlaceDetailsElectricity";
import { PlaceDetailsGas } from "../models/PlaceDetailsGas";
import { Page } from 'src/app/shared/model/page';
import { PlaceFilterForm } from '../../operator/models/PlaceFilterForm';
import { NetworkContractFilterForm } from '../../operator/models/NetworkContractFilterForm';
import { RequestFilterForm } from '../../operator/models/RequestFilterForm';

@Injectable({
  providedIn: 'root'
})
export class FinalClientService {

  constructor(private http: HttpClient) {
  }

  associateFCElectricityConsumptionPlace(code: string): Observable<any> {
    const params = new HttpParams().set('code', code);
    return this.http.post(environment.loggedInUrl + '/client-final/asociaza-loc-consum-energie-electrica', {}, { params });
  }

  associateFCGasConsumptionPlace(code: string): Observable<any> {
    const params = new HttpParams().set('code', code);
    return this.http.post(environment.loggedInUrl + '/client-final/asociaza-loc-consum-gaze-naturale', {}, { params });
  }

  disassociateFCConsumptionPlace(code: string): Observable<any> {
    const params = new HttpParams().set('code', code);
    return this.http.post(environment.loggedInUrl + '/client-final/dezasociaza-loc-consum', {}, { params });
  }

  getFCElectricityConsumptionPlace(placeId: number): Observable<PlaceDetailsElectricity> {
    return this.http.get<PlaceDetailsElectricity>(environment.loggedInUrl + `/client-final/detalii-loc-consum/${placeId}`);
  }

  getFCGasConsumptionPlace(placeId: number): Observable<PlaceDetailsGas> {
    return this.http.get<PlaceDetailsGas>(environment.loggedInUrl + `/client-final/gas/detalii-loc-consum/${placeId}`);
  }

  getFCElectricityConsumptionPlaces(placeFilterForm: PlaceFilterForm): Observable<Page<Place>> {
    return this.http.post<Page<Place>>(environment.loggedInUrl + '/client-final/energie-electrica/locuri-de-consum', placeFilterForm);
  }

  getFCElectricityContracts(contractFilterForm: NetworkContractFilterForm, placeId?: number): Observable<Page<any>> {
    if (placeId) {
      contractFilterForm.placeId = placeId;
    }
    return this.http.post<Page<any>>(environment.baseUrl + '/contract-furnizare/client-final/electricitate', contractFilterForm);
  }

  getFCElectricityRequests(electricityRequestFilterForm: RequestFilterForm): Observable<Page<any>> {
    return this.http.post<Page<any>>(environment.baseUrl + `/cerere/client-final/electricitate`, electricityRequestFilterForm);
  }

  getFCGasConsumptionPlaces(placeFilterForm: PlaceFilterForm): Observable<Page<Place>> {
    return this.http.post<Page<Place>>(environment.loggedInUrl + '/client-final/gaze-naturale/locuri-de-consum', placeFilterForm);
  }

  getFCGasContracts(contractFilterForm: NetworkContractFilterForm, placeId?: number): Observable<Page<any>> {
    if (placeId) {
      contractFilterForm.placeId = placeId;
    }
    return this.http.post<Page<any>>(environment.baseUrl + '/contract-furnizare/client-final/gaze', contractFilterForm);
  }

  getFCGasRequests(gasRequestFilterForm: RequestFilterForm): Observable<Page<any>> {
    return this.http.post<Page<any>>(environment.baseUrl + `/cerere/client-final/gaze`, gasRequestFilterForm);
  }

  cancelRequest(id: number): Observable<void> {
    return this.http.put<void>(environment.baseUrl + `/cerere/${id}/anulare`, {});
  }

  cancelContract(id: number): Observable<void> {
    return this.http.put<void>(environment.baseUrl + `/contract-furnizare/${id}/anulare`, {});
  }
}
